import React, { Key } from 'react';
import { Form, FormInstance, Popconfirm } from 'antd';

import { EPButton } from '@/components';
import IconDelete from '@/assets/icon-delete.svg?react';

interface RemoveAccessButtonProps {
  field: {
    name: string | number;
    fieldKey?: Key;
  };
  remove: (name: number | number[]) => void;
  form: FormInstance;
  t: (key: string) => string;
  isFormDisabled: boolean;
  isEditingSelfUser: boolean;
}

const RemoveAccessButton: React.FC<RemoveAccessButtonProps> = ({
  field,
  remove,
  form,
  t,
  isFormDisabled,
  isEditingSelfUser,
}) => {
  const stationList = form.getFieldValue('stationAndSubscriptions');
  if (stationList.length <= 1) return null;

  return (
    <Form.Item label="" name="remove">
      <Popconfirm
        placement="rightTop"
        okText={t('Remove access')}
        cancelText={t('Cancel')}
        icon={null}
        title={t("You are about to remove this user's access to this station. Are you sure?")}
        onConfirm={() => remove(Number(field.name))}
      >
        <EPButton
          type="link"
          icon={<IconDelete className="btn-remove-user-station" />}
          disabled={isFormDisabled || isEditingSelfUser}
        />
      </Popconfirm>
    </Form.Item>
  );
};

export default RemoveAccessButton;
